// Updated instruments with performerTitle for display (e.g. "feat. bassist Derek Whyte")

export interface Instrument {
  id: string;
  name: string;
  performerTitle: string;
}

export const instruments: { label: string; options: Instrument[] }[] = [
  {
    label: 'Rhythm Section',
    options: [
      { id: 'acoustic-piano',      name: 'Acoustic Piano',       performerTitle: 'pianist' },
      { id: 'electric-piano',      name: 'Electric Piano',       performerTitle: 'pianist' },
      { id: 'organ',               name: 'Organ',                performerTitle: 'organist' },
      { id: 'keyboard',            name: 'Keyboard',             performerTitle: 'keyboardist' },
      { id: 'electric-organ',      name: 'Electric Organ',       performerTitle: 'organist' },
      { id: 'rhodes',              name: 'Rhodes',               performerTitle: 'pianist' },
      { id: 'acoustic-guitar',     name: 'Acoustic Guitar',      performerTitle: 'guitarist' },
      { id: 'electric-guitar',     name: 'Electric Guitar',      performerTitle: 'guitarist' },
      { id: 'acoustic-bass',       name: 'Acoustic Bass',        performerTitle: 'bassist' },
      { id: 'electric-bass',       name: 'Electric Bass',        performerTitle: 'bassist' },
      { id: 'drum-kit',            name: 'Acoustic Drum Kit',    performerTitle: 'drummer' },
      { id: 'electronic-drum-kit', name: 'Electronic Drum Kit',  performerTitle: 'drummer' },
    ],
  },
  {
    label: 'Brass Section',
    options: [
      { id: 'trumpet',        name: 'Trumpet',        performerTitle: 'trumpeter' },
      { id: 'flugelhorn',     name: 'Flugelhorn',     performerTitle: 'flugelhornist' },
      { id: 'cornet',         name: 'Cornet',         performerTitle: 'cornetist' },
      { id: 'trombone',       name: 'Trombone',       performerTitle: 'trombonist' },
      { id: 'bass-trombone',  name: 'Bass Trombone',  performerTitle: 'trombonist' },
      { id: 'french-horn',    name: 'French Horn',    performerTitle: 'horn player' },
      { id: 'tuba',           name: 'Tuba',           performerTitle: 'tuba player' },
      { id: 'euphonium',      name: 'Euphonium',      performerTitle: 'euphoniumist' },
      { id: 'sousaphone',     name: 'Sousaphone',     performerTitle: 'sousaphonist' },
      { id: 'bugle',          name: 'Bugle',          performerTitle: 'bugler' },
      { id: 'baritone-horn',  name: 'Baritone Horn',  performerTitle: 'baritone horn player' },
      { id: 'tenor-horn',     name: 'Tenor Horn',     performerTitle: 'horn player' },
      { id: 'alto-horn',      name: 'Alto Horn',      performerTitle: 'horn player' },
      { id: 'mellophone',     name: 'Mellophone',     performerTitle: 'mellophonist' },
    ],
  },
  {
    label: 'Reed Section',
    options: [
      { id: 'alto-sax',       name: 'Alto Saxophone',    performerTitle: 'saxophonist' },
      { id: 'tenor-sax',      name: 'Tenor Saxophone',   performerTitle: 'saxophonist' },
      { id: 'baritone-sax',   name: 'Baritone Saxophone',performerTitle: 'saxophonist' },
      { id: 'bass-sax',       name: 'Bass Saxophone',    performerTitle: 'saxophonist' },
      { id: 'soprano-sax',    name: 'Soprano Saxophone', performerTitle: 'saxophonist' },
      { id: 'clarinet',       name: 'Clarinet',          performerTitle: 'clarinettist' },
      { id: 'bass-clarinet',  name: 'Bass Clarinet',     performerTitle: 'clarinettist' },
      { id: 'flute',          name: 'Acoustic Flute',    performerTitle: 'flautist' },
      { id: 'electric-flute', name: 'Electric Flute',    performerTitle: 'flautist' },
      { id: 'piccolo',        name: 'Piccolo',           performerTitle: 'piccoloist' },
      { id: 'oboe',           name: 'Oboe',              performerTitle: 'oboist' },
      { id: 'english-horn',   name: 'English Horn',      performerTitle: 'oboist' },
      { id: 'bassoon',        name: 'Bassoon',           performerTitle: 'bassoonist' },
      { id: 'contrabassoon',  name: 'Contrabassoon',     performerTitle: 'bassoonist' },
      { id: 'bagpipes',       name: 'Bagpipes',          performerTitle: 'piper' },
      { id: 'didgeridoo',     name: 'Didgeridoo',        performerTitle: 'didgeridoo player' },
      { id: 'harmonica',      name: 'Harmonica',         performerTitle: 'harmonica player' },
      { id: 'accordion',      name: 'Accordion',         performerTitle: 'accordionist' },
      { id: 'melodica',       name: 'Melodica',          performerTitle: 'melodica player' },
      { id: 'pan-flute',      name: 'Pan Flute',         performerTitle: 'flautist' },
      { id: 'shakuhachi',     name: 'Shakuhachi',        performerTitle: 'shakuhachi player' },
      { id: 'ocarina',        name: 'Ocarina',           performerTitle: 'ocarina player' },
      { id: 'tin-whistle',    name: 'Tin Whistle',       performerTitle: 'whistle player' },
      { id: 'recorder',       name: 'Recorder',          performerTitle: 'recorder player' },
      { id: 'saxophone',      name: 'Saxophone',         performerTitle: 'saxophonist' },
    ],
  },
  {
    label: 'Strings',
    options: [
      { id: 'violin',               name: 'Acoustic Violin',       performerTitle: 'violinist' },
      { id: 'electric-violin',      name: 'Electric Violin',       performerTitle: 'violinist' },
      { id: 'viola',                name: 'Acoustic Viola',        performerTitle: 'violist' },
      { id: 'electric-viola',       name: 'Electric Viola',        performerTitle: 'violist' },
      { id: 'cello',                name: 'Acoustic Cello',        performerTitle: 'cellist' },
      { id: 'electric-cello',       name: 'Electric Cello',        performerTitle: 'cellist' },
      { id: 'double-bass',          name: 'Double Bass',           performerTitle: 'bassist' },
      { id: 'electric-upright-bass',name: 'Electric Upright Bass', performerTitle: 'bassist' },
      { id: 'mandolin',             name: 'Acoustic Mandolin',     performerTitle: 'mandolinist' },
      { id: 'electric-mandolin',    name: 'Electric Mandolin',     performerTitle: 'mandolinist' },
      { id: 'harp',                 name: 'Harp',                  performerTitle: 'harpist' },
      { id: 'banjo',                name: 'Banjo',                 performerTitle: 'banjo player' },
      { id: 'ukulele',              name: 'Ukulele',               performerTitle: 'ukulele player' },
      { id: 'guzheng',              name: 'Guzheng',               performerTitle: 'guzheng player' },
      { id: 'koto',                 name: 'Koto',                  performerTitle: 'koto player' },
      { id: 'sitar',                name: 'Sitar',                 performerTitle: 'sitarist' },
      { id: 'oud',                  name: 'Oud',                   performerTitle: 'oud player' },
      { id: 'lap-steel',            name: 'Lap Steel Guitar',      performerTitle: 'guitarist' },
      { id: 'pedal-steel',          name: 'Pedal Steel Guitar',    performerTitle: 'guitarist' },
      { id: 'slide-guitar',         name: 'Slide Guitar',          performerTitle: 'guitarist' },
      { id: 'dobro',                name: 'Dobro',                 performerTitle: 'guitarist' },
      { id: 'autoharp',             name: 'Autoharp',              performerTitle: 'autoharp player' },
      { id: 'zither',               name: 'Zither',                performerTitle: 'zither player' },
      { id: 'hurdy-gurdy',          name: 'Hurdy Gurdy',           performerTitle: 'hurdy-gurdy player' },
      { id: 'nyckelharpa',          name: 'Nyckelharpa',           performerTitle: 'nyckelharpa player' },
      { id: 'santoor',              name: 'Santoor',               performerTitle: 'santoor player' },
      { id: 'saz',                  name: 'Saz',                   performerTitle: 'saz player' },
      { id: 'bouzouki',             name: 'Bouzouki',              performerTitle: 'bouzouki player' },
      { id: 'balalaika',            name: 'Balalaika',             performerTitle: 'balalaika player' },
      { id: 'domra',                name: 'Domra',                 performerTitle: 'domra player' },
      { id: 'pipa',                 name: 'Pipa',                  performerTitle: 'pipa player' },
      { id: 'erhu',                 name: 'Erhu',                  performerTitle: 'erhu player' },
      { id: 'gamelan',              name: 'Gamelan',               performerTitle: 'gamelan player' },
      { id: 'kora',                 name: 'Kora',                  performerTitle: 'kora player' },
      { id: 'mbira',                name: 'Mbira',                 performerTitle: 'mbira player' },
      { id: 'santur',               name: 'Santur',                performerTitle: 'santur player' },
      { id: 'yangqin',              name: 'Yangqin',               performerTitle: 'yangqin player' },
      { id: 'qanun',                name: 'Qanun',                 performerTitle: 'qanun player' },
      { id: 'dulcimer',             name: 'Dulcimer',              performerTitle: 'dulcimer player' },
      { id: 'psaltery',             name: 'Psaltery',              performerTitle: 'psaltery player' },
      { id: 'harp-guitar',          name: 'Harp Guitar',           performerTitle: 'guitarist' },
      { id: 'harp-lute',            name: 'Harp Lute',             performerTitle: 'lutenist' },
      { id: 'guitar-viol',          name: 'Guitar Viol',           performerTitle: 'viol player' },
    ],
  },
  {
    label: 'Percussion/Mallet',
    options: [
      { id: 'vibraphone',         name: 'Vibraphone',        performerTitle: 'vibraphonist' },
      { id: 'marimba',            name: 'Marimba',           performerTitle: 'marimbist' },
      { id: 'xylophone',          name: 'Xylophone',         performerTitle: 'xylophonist' },
      { id: 'congas',             name: 'Acoustic Congas',   performerTitle: 'percussionist' },
      { id: 'electronic-congas',  name: 'Electronic Congas', performerTitle: 'percussionist' },
      { id: 'bongos',             name: 'Bongos',            performerTitle: 'percussionist' },
      { id: 'timbales',           name: 'Timbales',          performerTitle: 'percussionist' },
      { id: 'steel-pan',          name: 'Steel Pan',         performerTitle: 'steel pan player' },
      { id: 'tabla',              name: 'Tabla',             performerTitle: 'tabla player' },
      { id: 'djembe',             name: 'Djembe',            performerTitle: 'djembe player' },
      { id: 'cajon',              name: 'Cajon',             performerTitle: 'cajón player' },
      { id: 'bass-drum',          name: 'Bass Drum',         performerTitle: 'drummer' },
      { id: 'snare-drum',         name: 'Snare Drum',        performerTitle: 'drummer' },
      { id: 'tambourine',         name: 'Tambourine',        performerTitle: 'percussionist' },
      { id: 'shaker',             name: 'Shaker',            performerTitle: 'percussionist' },
      { id: 'triangle',           name: 'Triangle',          performerTitle: 'percussionist' },
      { id: 'cowbell',            name: 'Cowbell',           performerTitle: 'percussionist' },
      { id: 'woodblock',          name: 'Woodblock',         performerTitle: 'percussionist' },
      { id: 'percussion',         name: 'Percussion',        performerTitle: 'percussionist' },
    ],
  },
  {
    label: 'Modern/Electronic',
    options: [
      { id: 'synthesizer',    name: 'Synthesizer',         performerTitle: 'synthesist' },
      { id: 'sampler',        name: 'Sampler',             performerTitle: 'electronic musician' },
      { id: 'electronic-wind',name: 'EWI',                 performerTitle: 'wind instrumentalist' },
      { id: 'modular-synth',  name: 'Modular Synthesizer', performerTitle: 'synthesist' },
      { id: 'theremin',       name: 'Theremin',            performerTitle: 'thereminist' },
      { id: 'keytar',         name: 'Keytar',              performerTitle: 'keyboardist' },
      { id: 'drum-machine',   name: 'Drum Machine',        performerTitle: 'electronic musician' },
      { id: 'sequencer',      name: 'Sequencer',           performerTitle: 'electronic musician' },
      { id: 'turntable',      name: 'Turntable',           performerTitle: 'turntablist' },
    ],
  },
  {
    label: 'Vocal',
    options: [
      { id: 'vocals',       name: 'Vocals',        performerTitle: 'vocalist' },
      { id: 'beatbox',      name: 'Beatbox',       performerTitle: 'beatboxer' },
      { id: 'throat-singing',name:'Throat Singing', performerTitle: 'throat singer' },
      { id: 'tuvan',        name: 'Tuvan',         performerTitle: 'throat singer' },
      { id: 'inuit',        name: 'Inuit',         performerTitle: 'throat singer' },
      { id: 'yodeling',     name: 'Yodeling',      performerTitle: 'yodeler' },
      { id: 'scat',         name: 'Scat',          performerTitle: 'vocalist' },
      { id: 'rap',          name: 'Rap',           performerTitle: 'rapper' },
      { id: 'spoken-word',  name: 'Spoken Word',   performerTitle: 'spoken word artist' },
      { id: 'vocoder',      name: 'Vocoder',       performerTitle: 'vocalist' },
    ],
  },
  {
    label: 'Experimental',
    options: [
      { id: 'found-objects',         name: 'Found Objects',         performerTitle: 'musician' },
      { id: 'metal-percussion',      name: 'Metal Percussion',      performerTitle: 'percussionist' },
      { id: 'glass-harmonica',       name: 'Glass Harmonica',       performerTitle: 'glass harmonica player' },
      { id: 'waterphone',            name: 'Waterphone',            performerTitle: 'waterphone player' },
      { id: 'singing-bowl',          name: 'Singing Bowl',          performerTitle: 'singing bowl player' },
      { id: 'circuit-bending',       name: 'Circuit Bending',       performerTitle: 'circuit bender' },
      { id: 'feedback-manipulation', name: 'Feedback Manipulation', performerTitle: 'musician' },
      { id: 'tape-manipulation',     name: 'Tape Manipulation',     performerTitle: 'musician' },
      { id: 'field-recording',       name: 'Field Recording',       performerTitle: 'musician' },
      { id: 'granular-synthesis',    name: 'Granular Synthesis',    performerTitle: 'musician' },
    ],
  },
  {
    label: 'Prepared',
    options: [
      { id: 'prepared-piano',       name: 'Prepared Piano',        performerTitle: 'pianist' },
      { id: 'prepared-guitar',      name: 'Prepared Guitar',       performerTitle: 'guitarist' },
      { id: 'prepared-bass',        name: 'Prepared Bass',         performerTitle: 'bassist' },
      { id: 'prepared-drums',       name: 'Prepared Drums',        performerTitle: 'drummer' },
      { id: 'prepared-percussion',  name: 'Prepared Percussion',   performerTitle: 'percussionist' },
      { id: 'prepared-strings',     name: 'Prepared Strings',      performerTitle: 'string player' },
      { id: 'prepared-wind',        name: 'Prepared Wind',         performerTitle: 'wind player' },
      { id: 'prepared-electronics', name: 'Prepared Electronics',  performerTitle: 'electronic musician' },
      { id: 'prepared-vocals',      name: 'Prepared Vocals',       performerTitle: 'vocalist' },
      { id: 'prepared-instruments', name: 'Prepared Instruments',  performerTitle: 'musician' },
    ],
  },
];

// Flat lookup: instrument name → performer title
// e.g. "Acoustic Bass" → "bassist", "Alto Saxophone" → "saxophonist"
export const performerTitleByInstrument: Record<string, string> = Object.fromEntries(
  instruments.flatMap(group => group.options.map(i => [i.name, i.performerTitle]))
);
